<template>
  <div class="centerdiv">
    <h2>《数学长征管理端》</h2>
    <div v-html="getMsg" ></div>
    <br>
    <br>
    <br>
    <div>
    	<el-button type="primary" @click="getTjInfo" style="width:150px">刷新统计--数学长征</el-button>
    </div>
    <br>
    <div>
    	<el-row>
        <label>{{userCount}}</label><br>
        <label>{{rechargeNum}}</label><br>
        <label>{{consumeToday}}</label><br>
        <label>{{consumeAll}}</label><br>
        <label>{{shareToday}}</label><br>
        <label>{{shareAll}}</label><br>
        <label>{{userProblemCount}}</label><br>
        <label>{{loginUCToday}}</label><br>
        <label>{{loginUCMonth}}</label><br>
      </el-row>
    </div>
    <br>
    <br>
    <div>
    	<el-button type="primary" @click="getTjInfoFh" style="width:150px">刷新统计--烽火数学</el-button>
    </div>
    <br>
    <div>
    	<el-row>
        <label>{{onLineUserCount}}</label><br>
        <label>{{roomCount}}</label><br>
        <label>{{ppGameUsers}}</label><br>
        <label>{{onLineUsers}}</label><br>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getTjData, getTjDataFh } from '@/api/api_tj.js'
  export default {
    data () {
      return {
        value: '',
        userCount: '',
        userProblemCount: '',
        loginUCToday: '',
        loginUCMonth: '',
        rechargeNum: '',
        consumeToday: '',
        consumeAll: '',
        shareToday: '',
        shareAll: '',
        onLineUserCount: '',
        roomCount: '',
        ppGameUsers: '',
        onLineUsers: ''
      }
    },
    computed: {
      ...mapGetters([
        'welcome'
      ]),
      getMsg () {
        return '用于对数学长征App的数据进行管理，包括审核题目、审核评论、查看统计报表等。'
      }
    },
    mounted () {

    },
    methods: {
      getTjInfo () {
        console.log('----------getTjInfo----')
        getTjData().then((res) => {
          if (res.data) {
            this.userCount = '注册用户数：' + res.data.userCount
            this.userProblemCount = '用户新出题数：' + res.data.newUserProblemCount
            this.loginUCToday = '当日登陆不同用户数：' + res.data.loginUCToday
            this.loginUCMonth = '当月登陆不同用户数：' + res.data.loginUCMonth
            this.rechargeNum = '充值总数：' + res.data.rechargeNum
            this.consumeToday = '当日花费额(金币)：' + res.data.consumeToday
            this.consumeAll = '总花费额(金币)：' + res.data.consumeAll
            this.shareToday = '当日分享次数：' + res.data.shareToday
            this.shareAll = '总分享次数：' + res.data.shareAll
          } else {

          }
        })
      },
      getTjInfoFh () {
        getTjDataFh().then((res) => {
          if (res.data) {
            // console.log('----------res.data=----', res.data)
            this.onLineUserCount = '在线用户数：' + res.data.onlineUsers.length
            this.roomCount = '游戏房间数：' + res.data.rooms.length
            this.ppGameUsers = '正在匹配用户数：' + res.data.ppGameUsers.length
            let uNames = ''
            for (let i = 0; i < res.data.onlineUsers.length; i++) {
              if (i === 0) {
                uNames = res.data.onlineUsers[i].nick
              } else {
                uNames = uNames + ',' + res.data.onlineUsers[i].nick
              }
            }
            this.onLineUsers = '在线用户列表：' + uNames // JSON.stringify(res.data.onlineUsers)
          } else {

          }
        })
      }
    }
  }
</script>

<style scoped>
  .centerdiv{
    height: auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// welcome.vue?31ab0549